// Modul zur Anzeige des Moduls Personalkosten mit PKT
"use strict";

import module from "./module.js";

export default module;
